export default __webpack_public_path__ + "e8b75da8368dd85d6c56e4ddd7841382.png";